import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo } from "react";
import { getDomain } from "@shared/blocks/helpers";
import { getLinkTitle, getLinkDescription } from "../helpers";
import "./view.scss";
export const SubstackBlockView = memo(({ block }) => {
    const content = block.content;
    const url = content.url;
    const domain = getDomain(url);
    const sourceLabel = domain || "Substack";
    const title = getLinkTitle(content) || block.title || "";
    const description = getLinkDescription(content) || block.summary || "";
    const source = url ? (_jsx("a", { href: url, target: "_blank", rel: "noopener noreferrer", className: "substack-content__source", onClick: (e) => e.stopPropagation(), onMouseDown: (e) => e.stopPropagation(), children: sourceLabel })) : (_jsx("div", { className: "substack-content__source", children: sourceLabel }));
    return (_jsxs("div", { className: "substack-content", children: [source, title && _jsx("div", { className: "substack-content__title", children: title }), description && _jsx("div", { className: "substack-content__description", children: description })] }));
});
